import React, { useEffect, useRef } from 'react'
import './contextMenu.scss'

interface ContextMenuProps {
  isOpen: boolean
  onClose: () => void
  position: { x: number; y: number }
  children: React.ReactNode
}

export function ContextMenu({ isOpen, onClose, position, children }: ContextMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <>
      <div className="context-menu-backdrop" />
      <div
        ref={menuRef}
        className="context-menu"
        style={{
          left: position.x,
          top: position.y,
        }}
      >
        {children}
      </div>
    </>
  )
}

interface ContextMenuItemProps {
  onClick: () => void
  icon?: string
  children: React.ReactNode
  variant?: 'default' | 'danger'
}

export function ContextMenuItem({ onClick, icon, children, variant = 'default' }: ContextMenuItemProps) {
  const handleClick = () => {
    onClick()
  }

  return (
    <button
      className={`context-menu-item ${variant === 'danger' ? 'context-menu-item--danger' : ''}`}
      onClick={handleClick}
    >
      {icon && <i className="material-icons">{icon}</i>}
      <span>{children}</span>
    </button>
  )
}

export function ContextMenuDivider() {
  return <div className="context-menu-divider" />
}